import sections from '../../utils/theme-sections';
import openModal from '../../components/INF-Modal/openModal';
import { initProductCarousels } from '../../sections/INF-ProductOverview/carousel';
import { handleWaitlistClick } from '../Waitlist';
import {
  generateBreadcrumbs,
  buildReviewsHTML,
  buildPriceHTML,
  switchClearanceBadge,
  pushMonetateData,
} from './quickViewHelpers';
import { badgeValues } from '../ProductTile/ProductBadge';

export default (
  product_url,
  init_count,
  list_name,
  cart_edit_item_enabled = false,
  previous_variant_id = null,
  previous_variant_quantity = null,
  product_data = null,
) => {
  const modal = document.getElementById('QuickView');
  const quickViewContent = document.querySelector('[data-quick-view-content]');

  modal.classList.add('QuickView--loading');

  // Only empty the modal immediately if it's not already open
  if (!modal.classList.contains('Modal--open')) {
    quickViewContent.innerHTML = '';
  }

  openModal(modal);
  // Parse product data if it exists
  let product_data_formatted = null;
  if (product_data) {
    product_data_formatted = JSON.parse(product_data);
  }
  // Check if user is in US - if not, use fetch method instead of FastSimon
  const isUS = window.theme?.country_iso === 'US';

  if (product_data_formatted !== null) {
    const videoProduct = product_data_formatted.att.find((att) => att[0].includes('custom.original_video_source'));
    if (isUS && !product_data_formatted.v.includes('GIVEX') && !videoProduct) {
      handleFastSimonProduct(product_data_formatted, list_name, quickViewContent, modal);
      return;
    }
  }

  // Otherwise, proceed with the original fetch method
  let ajax_url;
  let new_url = product_url.split('#');
  new_url = new_url[0];

  ajax_url = product_url.includes('?') ? `${new_url}&view=ajax` : `${new_url}?view=ajax`;

  fetch(ajax_url)
    .then((response) => response.text())
    .then((response) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = response;

      // When the quick view modal is opened in the cart page, this parameter will be true
      // This will enable a serie of changes to the quick view modal
      if (cart_edit_item_enabled) {
        // Add Title heading
        const cartEditHeading = document.createElement('h1');
        cartEditHeading.classList.add('CartEditItem__title');
        cartEditHeading.textContent = 'Edit Your Item';
        tempDiv
          .querySelector('[data-quick-view-container]')
          .insertBefore(cartEditHeading, tempDiv.querySelector('#shopify-section-INF-ProductOverview'));

        // Replace amount X% off with any promo product messaging
        const promoMessage = tempDiv.querySelector('.ProductHeading__promo_message');
        const discountLabel = tempDiv.querySelector('.ProductHeading__discount');

        if (promoMessage && discountLabel) {
          discountLabel.innerHTML = promoMessage.innerHTML;
        }

        // Replace button label with 'UPDATE NOW' when quick view modal is openend in the cart page
        const addToBagButtonPod = tempDiv.querySelector('.ProductInfo__add-to-cart');
        const addToBagButton = tempDiv.querySelector('.ProductInfo__add-to-cart>button');
        addToBagButton.setAttribute('data-edit-cart-item', 'true');
        addToBagButton.name = 'edit';
        addToBagButton.title = 'Edit Cart Item';
        addToBagButton.removeAttribute('data-add-to-cart');
        addToBagButton.innerHTML = '<span data-edit-cart-item-text>Update Now</span>';

        // if the item is sold out, disable any interaction with the button and its container
        if (addToBagButton.disabled) {
          addToBagButtonPod.setAttribute('data-edit-cart-item', false);
          addToBagButton.setAttribute('data-edit-cart-item', false);
          addToBagButton.innerHTML = '<span data-edit-cart-item-text>Sold Out</span>';
        }

        // Replace form action with '/cart/update' when quick view modal is opened in the cart page
        // Set extra attributes like 'previous-variant-id' and 'previous-variant-quantity
        const formAddToBag = tempDiv.querySelector('.ProductInfo__form');
        const inputPreviousVariantId = document.createElement('input');
        const inputPreviousVariantQuantity = document.createElement('input');

        formAddToBag.setAttribute('data-edit-cart-item', 'true');
        inputPreviousVariantId.type = 'hidden';
        inputPreviousVariantId.setAttribute('name', 'previous-variant-id');
        inputPreviousVariantId.setAttribute('value', previous_variant_id);
        formAddToBag.appendChild(inputPreviousVariantId);
        inputPreviousVariantQuantity.type = 'hidden';
        inputPreviousVariantQuantity.setAttribute('name', 'previous-variant-quantity');
        inputPreviousVariantQuantity.setAttribute('value', previous_variant_quantity);
        formAddToBag.appendChild(inputPreviousVariantQuantity);

        // Replace View Details text content with 'View Full Details'
        const viewDetailsLink = tempDiv.querySelector('.ProductInfo__view-details');
        viewDetailsLink.innerHTML = 'View Full Details';

        // It goes off exclusively in cart page for mobile devices.
        // This would fix issue swiper images on iOS devices. It will include Android devices as well
        const imgArr = tempDiv.querySelectorAll('.swiper-main .ProductImages__image.lazyload');
        if (window.innerWidth < 767) {
          imgArr.forEach((img) => {
            img.src = img.dataset.src;
          });
        }
      }

      const product = tempDiv.querySelector('[data-quick-view-container]');
      const productJson = tempDiv.querySelector('[data-product-json]');

      // Remove any special animation classes and replace them with a simple fade-in
      product.querySelectorAll('.Animate, .AnimateOnLoad').forEach((el) => {
        el.className = el.className.replace(/(^|\s)Animate--\S+/g, '');
        el.classList.add('Animate--fade-in');
      });

      // Make the title a link
      const productTitle = product.querySelector('.ProductHeading__title');
      if (productTitle) {
        const titleText = productTitle.textContent;
        productTitle.innerHTML = `<a href="${product_url}" data-quickview-ignore>${titleText}</a>`;
      }

      // Set properly collection name. We set last BreadCrumb value here if it is existing. Othewise, it will set list_name argument
      const hasBreadcrumbLink = tempDiv.querySelector('.Breadcrumb__link>a:last-child');
      if (hasBreadcrumbLink) {
        product.setAttribute('data-collection', hasBreadcrumbLink.textContent);
      } else {
        product.setAttribute('data-collection', list_name);
      }

      // Set and update a new property on window.theme object whenever you open a quick view
      window.theme.quickViewCollection = hasBreadcrumbLink ? hasBreadcrumbLink.textContent : list_name;

      quickViewContent.innerHTML = '';
      quickViewContent.appendChild(product);
      quickViewContent.appendChild(productJson);

      // Mark QuickView as NOT built with FastSimon for other functions to identify
      modal.setAttribute('data-built-with-fastsimon', 'false');

      // Ensure Yotpo renders review widgets on first open
      try {
        if (window.location.pathname !== '/cart' && window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
          window.yotpo.refreshWidgets();
        }
      } catch (error) {
        console.log('Quickview: Error in yotpo refresh', error);
      }

      sections
        .getInstances('product')
        .then((instances) => {
          instances.forEach((instance) => {
            instance.trigger('section_load');
          });
        })
        .catch((err) => {
          console.error('Quickview error:', err);
        });

      const productImages = quickViewContent.querySelector('[data-product-images]');
      if (productImages) {
        productImages.id = `ProductCarousels${init_count}`;
        productImages.setAttribute('quick-view-carousel', true);

        const thumbs = quickViewContent.querySelector('#ProductCarousel-Thumbs');
        if (thumbs) {
          thumbs.setAttribute('data-as-nav-for', `#ProductCarousels${init_count}`);
          thumbs.id = `ProductCarousel-Thumbs${init_count}`;
        }

        const thumbCount = quickViewContent.querySelector('[data-thumb-count]');
        if (thumbCount) {
          thumbCount.setAttribute('data-thumb-count', init_count);
        }
        if (window.theme.breakpoints.current === 'mobile') {
          const quickViewMobile = document.querySelector('[data-quick-view-content] [data-quick-view-container]');
          if (quickViewMobile) {
            quickViewMobile.setAttribute('data-quickview-mobile', true);
          }
          const viewDetailsMobile = document.querySelector('.ProductInfo__view-details');
          if (viewDetailsMobile) {
            viewDetailsMobile.innerText = 'View Full Product Details';

            if (cart_edit_item_enabled) {
              viewDetailsMobile.innerText = 'View Full Details';
            }
          }
        }
      }

      // Trigger a custom event
      const event = new Event('shouldProcessProductData');
      document.dispatchEvent(event);

      initProductCarousels();

      // Ensure the right image is displayed
      document.addEventListener('DOMContentLoaded', () => {
        const selectedVariant = document.querySelector(
          '[data-product-info-container] .ProductOption__variant--selected',
        );
        if (selectedVariant) {
          selectedVariant.click();
        }
      });

      // Remove loading state and open modal immediately
      modal.classList.remove('QuickView--loading');
      openModal(modal);

      // Add event listener for QuickView modal close tracking (fetch path)
      const handleQuickViewCloseFetch = (e) => {
        if (e.detail && e.detail.id === 'QuickView') {
          try {
            if (window.dataLayer) {
              const productTitle =
                tempDiv.querySelector('.ProductHeading__title')?.textContent?.trim() || 'Unknown Product';
              const productIdFromUrl = product_url.split('/products/')[1]?.split('?')[0] || 'unknown';

              window.dataLayer.push({
                event: 'quick_view_closed',
                product_name: productTitle,
                product_id: productIdFromUrl,
                product_url: product_url,
                list_name: list_name,
              });
            }
          } catch (error) {
            console.warn('QuickView close GTM tracking error (fetch path):', error);
          }
          // Remove the event listener to prevent memory leaks
          document.removeEventListener('modalDidClose', handleQuickViewCloseFetch);
        }
      };

      // Add the event listener
      document.addEventListener('modalDidClose', handleQuickViewCloseFetch);

      // GTM: Track QuickView modal opened (fetch path)
      try {
        if (window.dataLayer) {
          const productTitle =
            tempDiv.querySelector('.ProductHeading__title')?.textContent?.trim() || 'Unknown Product';
          const productIdFromUrl = product_url.split('/products/')[1]?.split('?')[0] || 'unknown';

          window.dataLayer.push({
            event: 'quick_view_opened',
            product_name: productTitle,
            product_id: productIdFromUrl,
            product_url: product_url,
            list_name: list_name,
          });
        }
      } catch (error) {
        console.warn('QuickView GTM tracking error (fetch path):', error);
      }

      // Add waitlist button event listeners immediately
      const waitlistButtons = product.querySelectorAll('[data-waitlist-open="true"]');
      waitlistButtons.forEach((button) => {
        button.addEventListener('click', handleWaitlistClick);
      });

      // Check if we need to show final sale message for .97 prices
      const finalSaleElement = product.querySelector('.ProductInfo__clearance[data-show-for-clearance]');
      if (finalSaleElement) {
        const priceElement = product.querySelector('[data-product-price] span[role="text"]');
        if (priceElement) {
          const priceText = priceElement.textContent;
          const priceMatch = priceText.match(/\$?(\d+\.\d{2})/);
          const shouldShow = priceMatch && priceMatch[1].endsWith('.97');
          finalSaleElement.style.display = shouldShow ? 'block' : 'none';
        }
      }
    })
    .catch((error) => {
      console.error('Error fetching the AJAX URL:', error);
    });
};

// Function to handle FastSimon product data without fetch
const handleFastSimonProduct = (productData, listName, quickViewContent, modal) => {
  // Extract basic product information from FastSimon data
  const title = productData.l.replace(/((CLEARANCE)|(PLACEHOLDER))( - )/g, '');
  const productUrl = productData.u;
  const productId = productData.id;
  const pid = productData.pid || 'unknown';

  // Extract ALL images from FastSimon data (these are all product images)
  let allProductImages = productData.att?.find((att) => att[0] === 'Product images')?.[1] || [productData.t];
  allProductImages = allProductImages.filter((img) => img && img.trim() !== '');

  let badgeHTML = '';
  if (productData.att) {
    const tagArray = productData.att.find((att) => att[0] === 'Tag');
    if (tagArray) {
      const productTags = tagArray[1].map((tag) => tag.toLowerCase());

      // Choose the single canonical badge using the same priority as ProductTile/ProductBadge.js
      let selectedBadge = null;
      for (const badge of badgeValues) {
        if (badge.tag.some((t) => productTags.includes(t))) {
          selectedBadge = badge;
          break; // first match wins
        }
      }

      if (selectedBadge) {
        const badgeText = selectedBadge.text;
        const badgeType = selectedBadge.type;
        let badgeClasses = 'ProductBadge';

        if (badgeText === 'Sale' || badgeText === 'Clearance' || badgeType === 'limited_time') {
          badgeClasses += ' ProductBadge--red';
        }
        if (badgeType === 'evergreen') {
          badgeClasses += ' ProductBadge--white';
        }
        if (
          badgeType === 'promo' ||
          badgeType === 'promo2' ||
          badgeText === 'BOGO' ||
          (typeof badgeText === 'string' &&
            (badgeText.includes('% off') || badgeText.includes('OFF') || badgeText.includes('promo')))
        ) {
          badgeClasses += ' ProductBadge--purple';
        }
        if (badgeType === 'promo' && typeof badgeText === 'string' && badgeText.length <= 6) {
          badgeClasses += ' ProductBadge--purple-short';
        }

        badgeHTML = `<div class="${badgeClasses}"><span>${badgeText}</span></div>`;
      }
    }
  }

  // Fallback to no badge html
  if (!badgeHTML) {
    badgeHTML = ``;
  }

  // Extract variants from FastSimon data structure
  let variants = [];
  let shopifyVariants = [];
  let colors = [];
  let sizes = [];

  // Helper function to create Shopify-compatible variant
  const createShopifyVariant = (variant) => ({
    id: variant.variant_id,
    title: `${variant.Color || 'Default'} / ${variant.Size || 'One Size'}`,
    option1: variant.Color || 'Default',
    option2: variant.Size || 'One Size',
    option3: null,
    sku: variant.Barcode || pid,
    barcode: variant.Barcode || pid,
    price: variant.price || 0,
    compare_at_price: variant.compare_at_price || 0,
    available: variant.Sellable === true,
    inventory_quantity: variant.Sellable === true ? 999 : 0,
    featured_image: variant.image_url ? { src: variant.image_url } : null,
    public_title: `${variant.Color || 'Default'} / ${variant.Size || 'One Size'}`,
    requires_shipping: true,
    taxable: true,
    weight: 0,
  });

  // Check if we have proper FastSimon variants array
  if (productData.vra && Array.isArray(productData.vra) && productData.vra.length > 0) {
    // Parse the vra array structure: [variant_id, [["attribute", [value]], ...]]
    variants = productData.vra.map((variantArray) => {
      const variantId = variantArray[0];
      const attributes = variantArray[1];

      // Convert attribute array to object for easier access
      const variantData = {
        variant_id: variantId,
      };

      attributes.forEach((attr) => {
        const [key, values] = attr;
        // Take the first value from the array (most attributes have single values)
        variantData[key] = Array.isArray(values) ? values[0] : values;
      });

      // Helper function to parse USD price strings to cents
      const parseUSDPrice = (priceString) => {
        if (priceString && typeof priceString === 'string') {
          const priceMatch = priceString.match(/USD:(\d+\.\d+)/);
          if (priceMatch) {
            return Math.round(parseFloat(priceMatch[1]) * 100);
          }
        }
        return 0;
      };

      // Convert price from USD:XX.XX format to cents
      variantData.price = parseUSDPrice(variantData.Price);
      // Convert compare_at_price from USD:XX.XX format to cents
      variantData.compare_at_price = parseUSDPrice(variantData['Compare at price']);

      // Get the variant image from imgs array
      if (variantData.imgs && Array.isArray(variantData.imgs)) {
        variantData.image_url = variantData.imgs[0];
      }

      return variantData;
    });

    // Convert FastSimon variants to Shopify-compatible format
    shopifyVariants = variants.map(createShopifyVariant);

    // Extract unique colors and sizes from variants
    colors = [...new Set(variants.map((v) => v.Color).filter(Boolean))];
    sizes = [...new Set(variants.map((v) => v.Size).filter(Boolean))];
  } else {
    // Fallback: create basic variant from available data
    const basePrice = productData.p || productData.price || 0;
    variants = [
      {
        variant_id: `${productId}-default`,
        Color: 'Default',
        Size: 'One Size',
        price: basePrice,
        compare_at_price: productData.p_c || 0,
        Sellable: true,
        image_url: allProductImages[0] || productData.t,
        Barcode: pid,
      },
    ];

    // Create Shopify-compatible variant using the same helper function
    shopifyVariants = variants.map(createShopifyVariant);

    colors = ['Default'];
    sizes = ['One Size'];
  }

  // Build complete size/color lists from attributes and create filler variants for missing, sold-out combinations
  try {
    const attributeSizes = (productData.att?.find((att) => att[0] === 'Size')?.[1] || []).filter(Boolean);

    // Use attribute-provided sizes if present; fall back to derived sizes
    let fullSizeList = attributeSizes.length > 0 ? attributeSizes : sizes;

    // Only consider colors that have at least one available variant (so we can clone values from an in-stock variant of that color)
    const inStockColors = [
      ...new Set(shopifyVariants.filter((v) => v.available === true).map((v) => v.option1)),
    ].filter(Boolean);

    // Create filler variants for each missing size within an in-stock color
    inStockColors.forEach((colorValue) => {
      const representative =
        shopifyVariants.find((v) => v.option1 === colorValue && v.available === true) ||
        shopifyVariants.find((v) => v.option1 === colorValue);
      if (!representative) return;

      fullSizeList.forEach((sizeValue) => {
        const exists = shopifyVariants.some(
          (v) =>
            (v.option1 || '').toLowerCase() === String(colorValue).toLowerCase() &&
            (v.option2 || '').toLowerCase() === String(sizeValue).toLowerCase(),
        );
        if (!exists) {
          const fillerId = `filler-${productId}-${String(colorValue).toLowerCase().replace(/\s+/g, '_')}-${String(
            sizeValue,
          )
            .toLowerCase()
            .replace(/\s+/g, '_')}`;
          shopifyVariants.push({
            id: fillerId,
            title: `${colorValue || 'Default'} / ${sizeValue || 'One Size'}`,
            option1: colorValue || 'Default',
            option2: sizeValue || 'One Size',
            option3: null,
            sku: representative.sku,
            barcode: representative.barcode,
            price: representative.price,
            compare_at_price: representative.compare_at_price,
            available: false,
            inventory_quantity: 0,
            featured_image: representative.featured_image,
            public_title: `${colorValue || 'Default'} / ${sizeValue || 'One Size'}`,
            requires_shipping: true,
            taxable: true,
            weight: typeof representative.weight !== 'undefined' ? representative.weight : 0,
            _isFiller: true,
          });
        }
      });
    });

    // Override sizes with the full list for UI rendering
    if (fullSizeList.length > 0) {
      sizes = fullSizeList;
    }

    // Keep colors as-is; UI already filters to available colors
  } catch (err) {
    console.warn('Quickview (FS): Error creating filler variants', err);
  }

  // Ensure every variant has a featured_image.src (protocol-relative) for cart and UI consumers
  const toProtocolRelative = (url) => {
    if (!url || typeof url !== 'string') return '';
    return url.replace(/^https?:/, '');
  };

  shopifyVariants = (Array.isArray(shopifyVariants) ? shopifyVariants : []).map((variant) => {
    const existingSrc =
      variant && variant.featured_image && typeof variant.featured_image.src === 'string'
        ? variant.featured_image.src
        : '';
    let currentSrc = existingSrc;
    if (!currentSrc) {
      const barcode = (variant && variant.barcode) || '';
      const byBarcode = Array.isArray(allProductImages)
        ? allProductImages.find((img) => barcode && typeof img === 'string' && img.includes(barcode))
        : null;
      currentSrc = byBarcode || (Array.isArray(allProductImages) ? allProductImages[0] : '') || '';
    }
    const normalizedSrc = toProtocolRelative(currentSrc);
    return {
      ...variant,
      featured_image: { src: normalizedSrc },
    };
  });

  // Create media array in Shopify format for updateSelectedVariant
  const mediaArray = allProductImages.map((imageUrl, index) => ({
    id: index + 1,
    media_type: 'image',
    src: imageUrl,
    alt: title,
    position: index + 1,
  }));

  // Create product tags for compatibility
  const productTags = productData.att?.find((att) => att[0] === 'Tag')?.[1] || [];

  // Select the first available variant as default
  const selectedVariant = shopifyVariants.find((v) => v.available === true) || shopifyVariants[0];
  const selectedColor = selectedVariant?.option1 || colors[0];
  const selectedSize = selectedVariant?.option2 || sizes[0];

  // Get images for the selected color (all variants of the same color share the same image)
  let variantImages = [];
  if (selectedColor && selectedColor !== 'Default') {
    // Get all unique images for this color
    const colorVariants = variants.filter((v) => v.Color === selectedColor);
    const colorImages = [...new Set(colorVariants.map((v) => v.image_url).filter(Boolean))];
    if (colorImages.length > 0) {
      variantImages = colorImages;
    } else {
      // Fallback to all product images
      variantImages = allProductImages;
    }
  } else {
    // For default or when no specific color, use all product images
    variantImages = allProductImages;
  }

  // Build image carousel HTML
  const buildImageCarousel = () => {
    const breadcrumbsHTML = generateBreadcrumbs(selectedVariant?.barcode);

    // Filter variantImages to only include images that match the selected variant's barcode
    const selectedVariantBarcode = selectedVariant?.barcode;
    const filteredVariantImages = variantImages.filter((img) => {
      return selectedVariantBarcode && img.includes(selectedVariantBarcode);
    });

    // If no filtered images found, fall back to all images
    const imagesToUse = filteredVariantImages.length > 0 ? filteredVariantImages : variantImages;

    const thumbsHTML = imagesToUse
      .map(
        (img, index) => `
      <div class="ProductImages__thumbs-placeholder swiper-slide ${
        index === 0 ? 'swiper-slide-thumb-active swiper-slide-visible swiper-slide-active' : ''
      }" data-product-images-thumb="" role="group" aria-label="${index + 1} / ${imagesToUse.length}">
        <img data-product-images-thumbs-slide="" src="${img}" alt="${title}" width="auto" height="auto">
      </div>
    `,
      )
      .join('');

    const mainSlidesHTML = imagesToUse
      .map(
        (img, index) => `
      <div class="swiper-slide ${index === 0 ? 'swiper-slide-active' : ''}" role="group" aria-label="${index + 1} / ${
        imagesToUse.length
      }">
        <img data-product-images-slide="" class="ProductImages__image${index === 0 ? '' : ' lazyload'}" ${
          index === 0 ? `src="${img}" fetchpriority="high" loading="eager"` : `data-src="${img}" data-expand="-20"`
        } alt="${title}" width="633" height="715" data-count="${index + 1}">
      </div>
    `,
      )
      .join('');

    return `
      <div class="ProductImages__Wrapper" data-thumb-count="${imagesToUse.length}">
        <div class="ProductImages__ThumbsContainer">
          <div id="ProductCarousel-Thumbs2" class="ProductImages__thumbnail" data-product-images-thumbs="" data-product-images-thumbs-wrapper="">
            <div class="swiper-thumbs swiper swiper-initialized swiper-vertical" data-product-images-thumbs-wrapper="">
              <div class="swiper-wrapper">${thumbsHTML}</div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <button class="swiper-button-next swiper-buttons swiper-button-thumbs"></button>
          <button class="swiper-button-prev swiper-buttons swiper-button-thumbs"></button>
        </div>
        
        <div class="ProductImages__Container">
          ${breadcrumbsHTML}
          
          <div class="ProductImages__wrapper">
            ${badgeHTML}
            
            <div id="ProductCarousels2" class="ProductImages" data-product-images="" data-product-images-carousel="" quick-view-carousel="true">
              <div class="swiper swiper-main swiper-initialized swiper-horizontal">
                <div class="swiper-wrapper">${mainSlidesHTML}</div>
              </div>
              <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
              <div class="ProductImages__zoom-icon" data-zoom-open="">
                <div class="ProductImages__zoom-icon--item"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  // Add CSS to override display: none for QuickView color swatches
  const addQuickViewStyles = () => {
    const styleId = 'quickview-color-swatch-fix';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        #QuickView .isp-product-color-swatch {
          display: inline-block !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
        #QuickView .ProductOption__variant-custom--color {
          display: inline-block !important;
          visibility: visible !important;
        }
      `;
      document.head.appendChild(style);
    }
  };

  // Ensure color swatches are visible after QuickView loads
  const ensureColorSwatchesVisible = () => {
    const quickViewModal = document.querySelector('#QuickView');
    if (quickViewModal) {
      const colorSwatches = quickViewModal.querySelectorAll('.isp-product-color-swatch');
      colorSwatches.forEach((swatch) => {
        swatch.style.display = 'inline-block';
        swatch.style.visibility = 'visible';
        swatch.style.opacity = '1';
      });
    }
  };

  // Add styles and ensure visibility
  addQuickViewStyles();
  ensureColorSwatchesVisible();

  // Build variant options HTML
  const buildColorOptions = () => {
    // Filter colors to only include those with available variants
    const availableColors = colors.filter((color) =>
      shopifyVariants.some((v) => v.option1 === color && v.available === true),
    );

    return availableColors
      .map((color) => {
        const isSelected = color === selectedColor;
        const variant = shopifyVariants.find((v) => v.option1 === color && v.available === true);
        // Use the same class generation as ProductInfo__options.liquid
        const colorClass = color
          .replace(/[0-9]/g, '') // Remove numbers
          .toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with hyphens
          .replace(/-/g, '_'); // Replace hyphens with underscores (handleize behavior)

        return `
        <li>
          <button type="button" aria-label="Select: ${color}" class="ProductOption__variant-custom ProductOption__variant-custom--color isp-product-color-swatch isp-product-color-swatch-${colorClass} ${
            isSelected ? 'ProductOption__variant--selected' : ''
          }" data-value="${color}" data-color-variant-selector="" data-custom-variant-selector="" data-variant-barcode="${
            variant?.barcode || pid
          }" aria-checked="${isSelected}" aria-label="Color: ${color}">
            <span class="color-swatch" aria-hidden="true"></span>
          </button>
        </li>
      `;
      })
      .join('');
  };

  const buildSizeOptions = () => {
    // Use all known sizes
    const allSizes = sizes;
    const filteredSizes = allSizes;

    // Comprehensive sorting arrays for all size types
    const sort_nums = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '5.5',
      '6',
      '6.5',
      '7',
      '7.5',
      '8',
      '8.5',
      '9',
      '9.5',
      '10',
      '10.5',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
      '32',
      '33',
      '50',
      '75',
      '100',
      '200',
      '300',
      '500',
    ];

    const sort_sizes = [
      'NS',
      'XXS',
      'XS',
      'XS/S',
      'S',
      'S/M',
      'M',
      'M/L',
      'L',
      'L/XL',
      'XL',
      '1XL',
      'XXL',
      '2XL',
      '3XL',
    ];

    const sort_mult = ['1X', '2X', '2X/3X', '3X'];

    const sort_letters = ['A', 'A/B', 'B', 'BC', 'C', 'C/D', 'D', 'D/DD', 'DD', 'K', 'L', 'M'];

    const sort_bras = [
      '30A',
      '30B',
      '30C',
      '30D',
      '32A',
      '32B',
      '32C',
      '32D',
      '34A',
      '34B',
      '34C',
      '34D',
      '36A',
      '36B',
      '36C',
      '36D',
      '38A',
      '38B',
      '38C',
      '38D',
      '40A',
      '40B',
      '40C',
      '40D',
    ];

    // Enhanced sorting function that handles all size types
    const getSortIndex = (size) => {
      const sizeStr = String(size).toUpperCase().trim();

      // Check bra sizes first (most specific)
      let index = sort_bras.findIndex((s) => s.toUpperCase() === sizeStr);
      if (index !== -1) return index;

      // Check standard sizes
      index = sort_sizes.findIndex((s) => s.toUpperCase() === sizeStr);
      if (index !== -1) return 1000 + index;

      // Check mult sizes (1X, 2X, etc.)
      index = sort_mult.findIndex((s) => s.toUpperCase() === sizeStr);
      if (index !== -1) return 2000 + index;

      // Check letter sizes
      index = sort_letters.findIndex((s) => s.toUpperCase() === sizeStr);
      if (index !== -1) return 3000 + index;

      // Check numeric sizes
      index = sort_nums.findIndex((s) => s === sizeStr || s === size);
      if (index !== -1) return 4000 + index;

      // Default: put unknown sizes at the end, sorted alphabetically
      return 10000 + sizeStr.charCodeAt(0);
    };

    const sortedSizes = [...filteredSizes].sort((a, b) => {
      const ai = getSortIndex(a);
      const bi = getSortIndex(b);
      if (ai !== bi) return ai - bi;
      // If same category, sort alphabetically as fallback
      return String(a).localeCompare(String(b), undefined, { sensitivity: 'base' });
    });

    return sortedSizes
      .map((size) => {
        const isSelected = size.toUpperCase() == selectedSize.toUpperCase();
        const isAvailable = shopifyVariants.some(
          (v) => v.option2 && v.option2.toLowerCase() === size.toLowerCase() && v.available === true,
        );

        return `
        <li>
          <button type="button" class="ProductOption__variant ProductOption__variant--sizes ${
            isSelected ? 'ProductOption__variant--selected' : ''
          } ${
            !isAvailable ? 'ProductOption__variant--sold-out' : ''
          }" aria-label="Size: ${size}" data-value="${size}" data-size-variant-selector="" data-custom-variant-selector="" >${size}</button>
        </li>
      `;
      })
      .join('');
  };

  // Build promo message HTML using the same logic as ProductHeading.liquid
  const buildPromoMessage = (productTags) => {
    const productSpecificMessaging = window.theme?.product_specific_messaging;
    const productSpecificTag = window.theme?.product_specific_messaging_tag;
    const productSpecificPdp = window.theme?.product_specific_messaging_pdp;
    const pdpPromoMessaging = window.theme?.pdp_promo_messaging;
    const pdpPromoMessagingFullpriceOnly = window.theme?.pdp_promo_messaging_fullprice_only;

    // Check if product has the specific tag for product-specific messaging
    const hasProductSpecificTag = productTags.some((tag) => tag.toLowerCase() === productSpecificTag?.toLowerCase());

    // Check if product has 'Full Price' tag
    const hasFullPriceTag = productTags.some((tag) => tag.toLowerCase() === 'full price');

    let promoMessage = '';

    if (productSpecificMessaging && hasProductSpecificTag && productSpecificPdp) {
      promoMessage = productSpecificPdp;
    } else if (!pdpPromoMessagingFullpriceOnly && pdpPromoMessaging) {
      promoMessage = pdpPromoMessaging;
    } else if (pdpPromoMessagingFullpriceOnly && hasFullPriceTag && pdpPromoMessaging) {
      promoMessage = pdpPromoMessaging;
    }

    if (!promoMessage) {
      return '';
    }

    return `
      <div class="ProductHeading__promo_message">
        <p><span style="color: #633293;">${promoMessage}</span></p>
      </div>
    `;
  };

  // Build QuadPay widget HTML
  const buildQuadPayWidget = (variant) => {
    // Check if we're in US and price is above threshold
    const isUS = window.theme?.country_iso === 'US';
    const priceInCents = variant?.price || 0;

    // Only show for US customers and prices above $35
    if (!isUS) {
      return '';
    }

    let amount;
    if (priceInCents > 3500) {
      amount = (priceInCents + 400) / 100; // Add $4.00
    } else {
      amount = priceInCents / 100;
    }
    const zippayMid = window.theme?.zippay_mid || '9caa4f73-ee7f-4c35-a4b2-bfe039368915';

    return `
      <div class="ProductHeading__quadpay" style="min-height: 20px; display: block;">
        <quadpay-widget-v3 
          amount="${amount}" 
          merchantId="${zippayMid}"
          learnMoreURL="https://zip.co/us/how-it-works" 
          min="35" 
          max="1600" 
          logoColor="#1D73EC" 
          logoSize="60%" 
          logoTextColor="#ffffff" 
          widgetVerbiage="4-easy-payments" 
          size="70%">
        </quadpay-widget-v3>
      </div>
    `;
  };

  // Check if variant should show low stock message
  const shouldShowLowStock = (productTags, variant) => {
    if (!variant || !variant.available) {
      return false;
    }
    // Find all tags that include "lowstock"
    const lowStockTags = productTags.filter((tag) => tag.toLowerCase().includes('lowstock'));
    if (!lowStockTags.length) {
      return false;
    }

    // Check if any of the low stock variant IDs match the current variant
    return lowStockTags.some((tag) => {
      // Extract variant ID from the LowStock tag (format: "LowStock:41895963230259")
      const lowStockVariantId = tag.split(':')[1];
      return lowStockVariantId && variant.id.toString() === lowStockVariantId;
    });
  };

  // Build low stock message HTML (always included, but hidden by default)
  const buildLowStockMessage = (productTags, variant) => {
    const shouldShow = shouldShowLowStock(productTags, variant);
    const displayStyle = shouldShow ? 'block' : 'none';

    return `
      <h5 class="ProductInfo__inventory" style="display:${displayStyle};" data-low-inventory-message>
        Almost Gone
      </h5>
    `;
  };

  // Check if variant price ends in .97
  const shouldShowFinalSale = (variant) => {
    if (!variant || !variant.price) {
      return false;
    }

    // Convert price from cents to dollars and check if it ends in .97
    return (
      variant.price.toString().endsWith('97') ||
      variant.price.toString().endsWith('96') ||
      productTags.some((tag) => tag.toLowerCase() === 'final sale')
    );
  };

  // Check if any size in the current color should show waitlist (sold out but not final sale)
  const shouldShowWaitlistForColor = (currentColor) => {
    // Get all variants for the current color
    const variantsInColor = shopifyVariants.filter((variant) => variant.option1 === currentColor);

    // Check if any variant in this color is sold out but not final sale
    return variantsInColor.some((variant) => !variant.available && !shouldShowFinalSale(variant));
  };

  // Build final sale message HTML (always included, but hidden by default)
  const buildFinalSaleMessage = (variant) => {
    const shouldShow = shouldShowFinalSale(variant);
    const displayStyle = shouldShow ? 'block' : 'none';

    return `
      <h5 class="ProductInfo__clearance" data-show-for-clearance style="display:${displayStyle};">
        FINAL SALE - NO RETURNS OR EXCHANGES
      </h5>
    `;
  };

  // Helper function to update QuadPay widget only if price changed
  const updateQuadPayWidgetIfPriceChanged = (newVariant, previousVariant) => {
    const quadpayWrapper = quickViewContent.querySelector('.ProductHeading__quadpay');
    if (quadpayWrapper && previousVariant) {
      // Calculate previous price with $4 addition logic
      let previousPrice;
      if (previousVariant.price > 3500) {
        previousPrice = (previousVariant.price + 400) / 100; // Add $4.00
      } else {
        previousPrice = previousVariant.price / 100;
      }

      // Calculate new price with $4 addition logic
      let newPrice;
      if (newVariant.price > 3500) {
        newPrice = (newVariant.price + 400) / 100; // Add $4.00
      } else {
        newPrice = newVariant.price / 100;
      }

      // Only update if price actually changed
      if (previousPrice !== newPrice) {
        quadpayWrapper.outerHTML = buildQuadPayWidget(newVariant);
      }
    }
  };

  const isMobile =
    (window.theme && window.theme.breakpoints && window.theme.breakpoints.current === 'mobile') ||
    (typeof window !== 'undefined' && window.innerWidth <= 989);
  const viewDetailsLabel = isMobile ? 'View Full Product Details' : 'View Details';

  // Build the complete QuickView HTML
  const quickViewHTML = `
    <div class="ProductGrid" data-section-type="product" data-enable-history-state="true" data-quick-view-container="" data-quickview-mobile="false" data-collection="Mini Dresses">
      <div id="shopify-section-INF-ProductOverview" class="shopify-section">
        <section id="SectionINF-ProductOverview" data-section-id="INF-ProductOverview" data-section-type="product" data-enable-history-state="true" class="Section Section--full Section--mobile-full">
          <div class="Section__container">
            
            <script type="application/json" data-product-video-data="">{}</script>
            
            <div class="ProductOverview" data-inventory-json='${JSON.stringify(
              shopifyVariants.reduce((acc, variant) => {
                acc[variant.id] = variant.inventory_quantity;
                return acc;
              }, {}),
            )}' data-price-json="%7B%7D">
              ${buildImageCarousel()}
            </div>
            
          </div>
        </section>
      </div>
      
      <div data-product-info-container="" class="ProductInfo">
        ${buildLowStockMessage(productTags, selectedVariant)}
        
        <div class="ProductHeading">
          <div class="ProductHeading__title-wrapper">
            <h1 class="ProductHeading__title" tabindex="0">
              <a href="${productUrl}" data-quickview-ignore="">${title}</a>
            </h1>
            ${buildReviewsHTML(
              productId,
              title,
              productUrl,
              variantImages[0] || allProductImages[0] || productData.t,
              productData.reviews_count || 0,
            )}
          </div>
          
          <div class="ProductHeading__row">
            ${buildPriceHTML(selectedVariant)}
          </div>
          
          ${buildQuadPayWidget(selectedVariant)}
          
          ${buildPromoMessage(productTags)}

          <div class="ProductHeading__spacing"></div>
        </div>
        
        <form class="ProductInfo__form" action="/cart/add" method="post" enctype="multipart/form-data" data-product-id="${productId}" data-reviews-average=${
          productData.reviews > 0 ? productData.reviews / 20 : 0
        } data-reviews-count=${productData.reviews_count} data-gtm-form-interact-id="1">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="properties[pid]" value="${pid}">
          
          <div class="ProductOptions" data-variant-barcode="${selectedVariant?.barcode || pid}">
            <div class="ProductOption ProductOption--half" data-custom-option-selector="option1" data-shopify-option-selector="#SingleOptionSelector-0">
              <div class="ProductOption__row">
                <div class="ProductOption__name">Color:<span data-color-variant-value="">${selectedColor}</span></div>
              </div>
              <ul class="ProductOption__variants ProductOption__variants--list ProductOption__variants--flex">
                ${buildColorOptions()}
              </ul>
            </div>
            
            <div class="ProductOption" data-custom-option-selector="option2" data-shopify-option-selector="#SingleOptionSelector-1">
              <div class="ProductOption__size">
                <div class="ProductOption__name">Size:<span data-size-variant-value="">${
                  /^[\d.]+$/.test(selectedSize) ? `US ${selectedSize}` : selectedSize.toUpperCase()
                }</span></div>
                <div class="ProductOption__size-guide QuickView--hide">
                  <a href="#product_size_guide" aria-label="size guide" data-open-modal>Size Guide</a>
                </div>
              </div>
              <ul class="ProductOption__variants ProductOption__variants--list ProductOption__variants--flex">
                ${buildSizeOptions()}
              </ul>
            </div>

            <div class="ProductOption__details">
              <div class="WaitlistModal ${
                shouldShowWaitlistForColor(selectedColor) ? 'WaitlistModal--show' : 'WaitlistModal--hide'
              }">
                <span class="ProductInfo__waitlist-link">Unavailable in your size?</span>
                <span class="ProductInfo__waitlist-text" data-product-id="${productId}" data-product-name="${title}" data-add-to-cart="false" data-waitlist-open="true">Join the Waitlist</span>
              </div>
            </div>
          </div>

          ${buildFinalSaleMessage(selectedVariant)}
          
          <div class="ProductInfo__add-to-cart">
            <button type="submit" name="add" title="Add to Cart" class="ProductInfo__button Button Button--primary" data-product-id="${productId}" data-product-name="${title}" data-add-to-cart="true">
              <span data-add-to-cart-text="">Add to Bag</span>
            </button>
          </div>
          
          <input type="hidden" name="product-id" value="${productId}">
          <input type="hidden" name="id" value="${selectedVariant?.id || productId}">
        </form>
        
         <a href="${productUrl}" class="ProductInfo__view-details Button Button--secondary" title="${viewDetailsLabel}" data-quickview-ignore="">${viewDetailsLabel}</a>
        
        <div class="SocialSharing">
          <div class="SocialSharing__right">
            <a target="_blank" href="//www.facebook.com/sharer.php?u=${encodeURIComponent(
              window.location.origin + productUrl,
            )}" data-quickview-ignore="">
              <i class="SocialSharing__icon fab fa-facebook"></i>
              <span class="SocialSharing__text">Share</span>
            </a>
            <a target="_blank" href="//pinterest.com/pin/create/button/?url=${encodeURIComponent(
              window.location.origin + productUrl,
            )}&media=${encodeURIComponent(variantImages[0])}&description=${encodeURIComponent(
              title,
            )}" data-quickview-ignore="">
              <i class="SocialSharing__icon fab fa-pinterest"></i>
              <span class="SocialSharing__text">Pin it</span>
            </a>
            <a href="mailto:user@domain.com?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(
              window.location.origin + productUrl,
            )}" data-quickview-ignore="">
              <i class="SocialSharing__icon far fa-envelope"></i>
              <span class="SocialSharing__text">email</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  `;

  // Set the HTML content
  quickViewContent.innerHTML = quickViewHTML;

  // Mark QuickView as built with FastSimon for other functions to identify
  const quickViewModal = document.getElementById('QuickView');
  if (quickViewModal) {
    quickViewModal.setAttribute('data-built-with-fastsimon', 'true');
  }

  // Prefetch canonical Shopify product JSON and attach for Waitlist to use
  try {
    const handleFromUrl = (productUrl.split('/products/')[1] || '').split('?')[0];
    if (handleFromUrl) {
      fetch(`/products/${handleFromUrl}.js`)
        .then((resp) => (resp.ok ? resp.json() : null))
        .then((canonicalData) => {
          if (!canonicalData) return;
          const canonicalScript = document.createElement('script');
          canonicalScript.type = 'application/json';
          canonicalScript.setAttribute('data-product-json-canonical', '');
          canonicalScript.textContent = JSON.stringify(canonicalData);
          const container = quickViewContent.querySelector('[data-section-type="product"]') || quickViewContent;
          container.appendChild(canonicalScript);
        })
        .catch((err) => {
          console.warn('Quickview (FS): canonical product fetch failed', err);
        });
    }
  } catch (e) {
    console.warn('Quickview (FS): error preparing canonical product fetch', e);
  }

  // Helper: Toggle Add to Cart button to Waitlist when variant is sold out
  const configureAddToCartButton = (variant) => {
    const addToCartButton = quickViewContent.querySelector('.ProductInfo__add-to-cart > button');
    const addToCartText = addToCartButton?.querySelector('[data-add-to-cart-text]');

    if (!addToCartButton || !addToCartText) return;

    if (!variant?.available) {
      const isFinalSale = shouldShowFinalSale(variant);

      if (isFinalSale) {
        // For final sale items, just show "Sold Out" without waitlist option
        addToCartButton.disabled = true;
        addToCartButton.removeAttribute('data-waitlist-open');
        addToCartButton.setAttribute('data-add-to-cart', false);
        addToCartButton.setAttribute('type', 'button');
        addToCartText.textContent = 'Sold Out';

        // Remove any existing waitlist click handler
        if (addToCartButton._waitlistClickHandlerRef) {
          addToCartButton.removeEventListener('click', addToCartButton._waitlistClickHandlerRef);
          addToCartButton._waitlistClickHandlerRef = null;
        }
      } else {
        // Regular sold out behavior with waitlist option
        addToCartButton.disabled = false;
        addToCartButton.setAttribute('data-waitlist-open', true);
        addToCartButton.setAttribute('data-add-to-cart', false);
        addToCartButton.setAttribute('type', 'button');
        addToCartText.innerHTML = `<span class="waitlist-toggle">Sold Out <span class="ProductInfo__waitlist-text" data-product-id="${productId}" data-product-name="${title}" data-add-to-cart="false">/ Join the Waitlist</span></span>`;

        // Ensure waitlist click opens the modal and does not submit/close QuickView
        if (addToCartButton._waitlistClickHandlerRef) {
          addToCartButton.removeEventListener('click', addToCartButton._waitlistClickHandlerRef);
        }
        addToCartButton._waitlistClickHandlerRef = (e) => {
          e.preventDefault();
          e.stopPropagation();
          try {
            handleWaitlistClick(e);
          } catch (err) {
            console.error('Waitlist open error:', err);
          }
        };
        addToCartButton.addEventListener('click', addToCartButton._waitlistClickHandlerRef);
      }
    } else {
      // Re-enable button for available variants
      addToCartButton.disabled = false;
      addToCartButton.setAttribute('data-add-to-cart', true);
      addToCartButton.removeAttribute('data-waitlist-open');
      addToCartButton.setAttribute('type', 'submit');
      addToCartText.textContent = 'Add to Bag';
      if (addToCartButton._waitlistClickHandlerRef) {
        addToCartButton.removeEventListener('click', addToCartButton._waitlistClickHandlerRef);
        addToCartButton._waitlistClickHandlerRef = null;
      }
    }
  };

  // Apply initial state for Add to Cart button
  configureAddToCartButton(selectedVariant);

  // Push initial Monetate data for QuickView load
  const initialProductJson = {
    id: productId,
    title: title,
    handle: productUrl.split('/products/')[1]?.split('?')[0] || '',
    vendor: 'Windsor',
    type: 'Regular',
    tags: productTags,
    variants: shopifyVariants,
    media: mediaArray,
    options: [
      { name: 'Color', values: colors },
      { name: 'Size', values: sizes },
    ],
    url: productUrl,
    featured_image: variantImages[0] || allProductImages[0] || productData.t,
  };
  pushMonetateData(selectedVariant, initialProductJson);

  // GTM: Track QuickView modal opened
  try {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'quick_view_opened',
        product_name: title,
        product_id: productId,
        product_url: productUrl,
        list_name: listName,
      });
    }
  } catch (error) {
    console.warn('QuickView GTM tracking error:', error);
  }

  // Add FastSimon tracking for add to cart form submission
  const addToCartForm = quickViewContent.querySelector('.ProductInfo__form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function () {
      // Only track if it's actually adding to cart (not waitlist)
      const addToCartButton = quickViewContent.querySelector('.ProductInfo__add-to-cart > button');
      const isAddToCart = addToCartButton && addToCartButton.getAttribute('data-add-to-cart') === 'true';

      if (isAddToCart) {
        // GTM: Track QuickView add to cart
        try {
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'quick_view_add_to_cart',
              product_name: title,
              product_id: productId,
              variant_id: selectedVariant?.id,
              color: selectedVariant?.option1,
              size: selectedVariant?.option2,
              price: selectedVariant?.price ? (selectedVariant.price / 100).toFixed(2) : '0.00',
            });
          }
        } catch (error) {
          console.warn('QuickView GTM add to cart tracking error:', error);
        }

        // FastSimon: Track add to cart
        if (window.FastSimonSDK && window.FastSimonEventName) {
          try {
            // Trigger FastSimon tracking after a short delay to ensure cart is updated
            setTimeout(() => {
              window.FastSimonSDK.event({
                eventName: window.FastSimonEventName.AddToCartPerformed,
                reportAppType: 'SPA',
                data: {
                  productID: [productId], // Use the current product ID
                },
              });
            }, 100);
          } catch (error) {
            console.warn('QuickView FastSimon tracking error:', error);
          }
        }
      }
    });
  }

  // Store product data for later use in Shopify-compatible format
  const productDataScript = document.createElement('script');
  productDataScript.type = 'application/json';
  productDataScript.setAttribute('data-product-json', '');
  productDataScript.textContent = JSON.stringify({
    id: productId,
    title: title,
    handle: productUrl.split('/products/')[1]?.split('?')[0] || '',
    vendor: 'Windsor',
    type: 'Regular',
    tags: productTags,
    variants: shopifyVariants,
    media: mediaArray,
    options: [
      { name: 'Color', values: colors },
      { name: 'Size', values: sizes },
    ],
    url: productUrl,
    featured_image: variantImages[0] || allProductImages[0] || productData.t,
    // Store FastSimon original data for reference
    fastsimon_data: {
      ...productData,
      processed_variants: variants,
      all_images: allProductImages,
      current_variant_images: variantImages,
    },
    selected_variant: selectedVariant,
  });
  quickViewContent.appendChild(productDataScript);

  // Ensure Yotpo renders review widgets on first open (FastSimon path)
  try {
    if (window.location.pathname !== '/cart' && window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      window.yotpo.refreshWidgets();
    }
  } catch (error) {
    console.log('Quickview (FS): Error in yotpo refresh', error);
  }

  // Bind waitlist triggers (FastSimon path): join-waitlist text and any [data-waitlist-open]
  try {
    const fsWaitlistTriggers = quickViewContent.querySelectorAll(
      '[data-waitlist-open="true"], .ProductInfo__waitlist-text',
    );
    fsWaitlistTriggers.forEach((el) => {
      // Prevent duplicate bindings
      if (el._fsWaitlistBound) return;
      el._fsWaitlistBound = true;
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          handleWaitlistClick(e);
        } catch (err) {
          console.error('Quickview (FS): Waitlist trigger error', err);
        }
      });
    });
  } catch (err) {
    console.error('Quickview (FS): Error binding waitlist triggers', err);
  }

  // Initialize sections and remove loading state
  sections
    .getInstances('product')
    .then((instances) => {
      instances.forEach((instance) => {
        instance.trigger('section_load');
      });
    })
    .then(() => {
      const reviewElement = quickViewContent.querySelector('[data-yotpo-quickview-reviews="true"]');
      if (reviewElement) {
        reviewElement.addEventListener('click', (e) => {
          e.preventDefault();
          const productUrl = reviewElement.getAttribute('data-yotpo-reviews-click-url');
          if (productUrl) {
            window.location.href = `${productUrl}#product-reviews`;
          }
        });
      }
    })
    .catch((err) => {
      console.error('FastSimon QuickView: Section initialization error:', err);
    });

  // Remove loading state
  modal.classList.remove('QuickView--loading');

  // Add event listener for QuickView modal close tracking
  const handleQuickViewClose = (e) => {
    if (e.detail && e.detail.id === 'QuickView') {
      try {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'quick_view_closed',
            product_name: title,
            product_id: productId,
            product_url: productUrl,
            list_name: listName,
          });
        }
      } catch (error) {
        console.warn('QuickView close GTM tracking error:', error);
      }
      // Remove the event listener to prevent memory leaks
      document.removeEventListener('modalDidClose', handleQuickViewClose);
    }
  };

  // Add the event listener
  document.addEventListener('modalDidClose', handleQuickViewClose);

  // Initialize product carousels
  if (typeof initProductCarousels === 'function') {
    initProductCarousels();
  }

  // Add variant switching functionality
  const colorButtons = quickViewContent.querySelectorAll('[data-color-variant-selector]');
  const sizeButtons = quickViewContent.querySelectorAll('[data-size-variant-selector]');

  // Track current variant for price comparison
  let currentVariant = selectedVariant;

  // Ensure color swatches are visible after content is loaded
  ensureColorSwatchesVisible();

  // Set initial sold out states
  const setInitialSoldOutStates = () => {
    // Set sold out states for size buttons based on current color
    sizeButtons.forEach((btn) => {
      const size = btn.dataset.value;
      const sizeVariant = shopifyVariants.find((v) => v.option1 === selectedColor && v.option2 === size);
      // Only mark as sold out if variant exists but is not available
      if (sizeVariant && !sizeVariant.available) {
        btn.classList.add('ProductOption__variant--sold-out');
      } else {
        btn.classList.remove('ProductOption__variant--sold-out');
      }
    });

    // Set sold out states for color buttons based on current size
    colorButtons.forEach((btn) => {
      const color = btn.dataset.value;
      const colorVariant = shopifyVariants.find((v) => v.option1 === color && v.option2 === selectedSize);
      // Only mark as sold out if variant exists but is not available
      if (colorVariant && !colorVariant.available) {
        btn.classList.add('ProductOption__variant--sold-out');
      } else {
        btn.classList.remove('ProductOption__variant--sold-out');
      }
    });
  };

  // Set initial sold out states
  setInitialSoldOutStates();

  if (window.theme?.country_iso === 'US') {
    colorButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const newColor = e.target.dataset.value;

        // Get the current size from the selected size button
        const currentSizeElement = quickViewContent.querySelector(
          '[data-size-variant-selector].ProductOption__variant--selected',
        );
        const currentSize = currentSizeElement?.dataset.value || selectedSize;

        // First try to find a variant with the new color and current size that's available
        let newVariant = shopifyVariants.find(
          (v) =>
            v.option1 === newColor && v.option2.toUpperCase() === currentSize.toUpperCase() && v.available === true,
        );

        // If no available variant found, try to find any variant with new color and current size
        if (!newVariant) {
          newVariant = shopifyVariants.find(
            (v) => v.option1 === newColor && v.option2.toUpperCase() === currentSize.toUpperCase(),
          );
        }

        // If still no variant found, fall back to any available variant with the new color
        if (!newVariant) {
          newVariant = shopifyVariants.find((v) => v.option1 === newColor && v.available === true);
        }

        if (newVariant) {
          // Update selected states
          colorButtons.forEach((btn) => btn.classList.remove('ProductOption__variant--selected'));
          e.target.classList.add('ProductOption__variant--selected');

          // Update main images for the new color (filter by barcode)
          let newVariantImages = [];
          const newVariantBarcode = newVariant?.barcode || pid;

          // Filter allProductImages to only include images that match the new variant's barcode
          const filteredImages = allProductImages.filter((img) => {
            return newVariantBarcode && img.includes(newVariantBarcode);
          });

          // If no filtered images found, fall back to all images
          newVariantImages = filteredImages.length > 0 ? filteredImages : allProductImages;

          // Update the carousel with new images
          const mainWrapper = quickViewContent.querySelector('.swiper-main .swiper-wrapper');
          const thumbsWrapper = quickViewContent.querySelector('.swiper-thumbs .swiper-wrapper');

          if (mainWrapper && thumbsWrapper) {
            // Update main slides (lazyload)
            mainWrapper.innerHTML = newVariantImages
              .map(
                (img, index) => `
                <div class="swiper-slide ${index === 0 ? 'swiper-slide-active' : ''}" role="group" aria-label="${
                  index + 1
                } / ${newVariantImages.length}">
                  <img data-product-images-slide="" class="ProductImages__image${index === 0 ? '' : ' lazyload'}" ${
                    index === 0
                      ? `src="${img}" fetchpriority="high" loading="eager"`
                      : `data-src="${img}" data-expand="-20"`
                  } alt="${title}" width="633" height="715" data-count="${index + 1}">
                </div>
              `,
              )
              .join('');

            // Update thumbnail slides
            thumbsWrapper.innerHTML = newVariantImages
              .map(
                (img, index) => `
                <div class="ProductImages__thumbs-placeholder swiper-slide ${
                  index === 0 ? 'swiper-slide-thumb-active swiper-slide-visible swiper-slide-active' : ''
                }" data-product-images-thumb="" role="group" aria-label="${index + 1} / ${newVariantImages.length}">
                  <img data-product-images-thumbs-slide="" src="${img}" alt="${title}" width="auto" height="auto">
                </div>
              `,
              )
              .join('');

            // Destroy existing carousel instances before re-initializing
            const existingMainSwiper = quickViewContent.querySelector('.swiper-main')?.swiper;
            const existingThumbsSwiper = quickViewContent.querySelector('.swiper-thumbs')?.swiper;

            if (existingMainSwiper) {
              existingMainSwiper.destroy(true, true);
            }
            if (existingThumbsSwiper) {
              existingThumbsSwiper.destroy(true, true);
            }

            // Re-initialize carousels
            if (typeof initProductCarousels === 'function') {
              initProductCarousels();
            }
          }

          // Update color display
          const colorDisplay = quickViewContent.querySelector('[data-color-variant-value]');
          if (colorDisplay) {
            colorDisplay.textContent = newColor;
          }

          // Update clearance badge based on variant price
          switchClearanceBadge(newVariant);

          // Update variant barcode
          const productOptions = quickViewContent.querySelector('.ProductOptions');
          if (productOptions) {
            productOptions.setAttribute('data-variant-barcode', newVariant.barcode || '');
          }

          // Update hidden variant ID input
          const variantInput = quickViewContent.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = newVariant.id;
          }

          // Update price display
          const priceWrapper = quickViewContent.querySelector('[data-price-wrapper]');
          if (priceWrapper) {
            priceWrapper.outerHTML = buildPriceHTML(newVariant);
          }

          // Update QuadPay widget only if price changed
          updateQuadPayWidgetIfPriceChanged(newVariant, currentVariant);

          // Update current variant reference
          currentVariant = newVariant;

          // Push Monetate data for color variant change
          const productJsonColor = {
            id: productId,
            title: title,
            handle: productUrl.split('/products/')[1]?.split('?')[0] || '',
            vendor: 'Windsor',
            type: 'Regular',
            tags: productTags,
            variants: shopifyVariants,
            media: mediaArray,
            options: [
              { name: 'Color', values: colors },
              { name: 'Size', values: sizes },
            ],
            url: productUrl,
            featured_image: variantImages[0] || allProductImages[0] || productData.t,
          };
          pushMonetateData(newVariant, productJsonColor);

          // Update promo message
          const promoMessageWrapper = quickViewContent.querySelector('.ProductHeading__promo_message');
          if (promoMessageWrapper) {
            promoMessageWrapper.outerHTML = buildPromoMessage(productTags);
          }

          // Show/hide waitlist based on whether any size in this color needs waitlist
          const waitlistModal = quickViewContent.querySelector('.WaitlistModal');
          if (waitlistModal) {
            if (shouldShowWaitlistForColor(newColor)) {
              waitlistModal.classList.remove('WaitlistModal--hide');
              waitlistModal.classList.add('WaitlistModal--show');
            } else {
              waitlistModal.classList.remove('WaitlistModal--show');
              waitlistModal.classList.add('WaitlistModal--hide');
            }
          }

          // Toggle Add to Cart button vs Waitlist
          configureAddToCartButton(newVariant);

          // Update sold out button states for sizes
          const sizeButtons = quickViewContent.querySelectorAll('[data-size-variant-selector]');
          sizeButtons.forEach((btn) => {
            const size = btn.dataset.value;
            const sizeVariant = shopifyVariants.find((v) => v.option1 === newColor && v.option2 === size);
            // Only mark as sold out if variant exists but is not available
            if (sizeVariant && !sizeVariant.available) {
              btn.classList.add('ProductOption__variant--sold-out');
            } else {
              btn.classList.remove('ProductOption__variant--sold-out');
            }
          });

          // Update low stock message visibility
          const lowStockMessageWrapper = quickViewContent.querySelector(
            '.ProductInfo__inventory[data-low-inventory-message]',
          );
          if (lowStockMessageWrapper) {
            const shouldShow = shouldShowLowStock(productTags, newVariant);
            lowStockMessageWrapper.style.display = shouldShow ? 'block' : 'none';
          }

          // Update final sale message visibility
          const finalSaleMessageWrapper = quickViewContent.querySelector(
            '.ProductInfo__clearance[data-show-for-clearance]',
          );
          if (finalSaleMessageWrapper) {
            const shouldShow = shouldShowFinalSale(newVariant);
            finalSaleMessageWrapper.style.display = shouldShow ? 'block' : 'none';
          }
        }
      });
    });

    sizeButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const newSize = e.target.dataset.value;

        // Get the current color from the selected color button
        const currentColorElement = quickViewContent.querySelector(
          '[data-color-variant-selector].ProductOption__variant--selected',
        );
        const currentColor = currentColorElement?.dataset.value || selectedColor;

        // First try to find a variant with the current color and new size that's available
        let newVariant = shopifyVariants.find(
          (v) =>
            v.option1 === currentColor && v.option2.toUpperCase() === newSize.toUpperCase() && v.available === true,
        );

        // If no available variant found, try to find any variant with current color and new size
        if (!newVariant) {
          newVariant = shopifyVariants.find(
            (v) => v.option1 === currentColor && v.option2.toUpperCase() === newSize.toUpperCase(),
          );
        }

        // If still no variant found, try case-insensitive match
        if (!newVariant) {
          newVariant = shopifyVariants.find(
            (v) => v.option1 === currentColor && v.option2 && v.option2.toLowerCase() === newSize.toLowerCase(),
          );
        }

        if (newVariant) {
          // Update selected states
          sizeButtons.forEach((btn) => btn.classList.remove('ProductOption__variant--selected'));
          e.target.classList.add('ProductOption__variant--selected');

          // Update size display
          const sizeDisplay = quickViewContent.querySelector('[data-size-variant-value]');
          if (sizeDisplay) {
            // Check if it's a shoe size (numeric, including decimals like 6.5)
            const isShoeSize = /^[\d.]+$/.test(newSize);
            sizeDisplay.textContent = isShoeSize ? `US ${newSize}` : newSize.toUpperCase();
          } else {
            console.warn('Size display element not found');
          }

          // Update clearance badge based on variant price
          switchClearanceBadge(newVariant);

          // Update variant barcode
          const productOptions = quickViewContent.querySelector('.ProductOptions');
          if (productOptions) {
            productOptions.setAttribute('data-variant-barcode', newVariant.barcode || '');
          }

          // Update hidden variant ID input
          const variantInput = quickViewContent.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = newVariant.id;
          }

          // Update price display
          const priceWrapper = quickViewContent.querySelector('[data-price-wrapper]');
          if (priceWrapper) {
            priceWrapper.outerHTML = buildPriceHTML(newVariant);
          }

          // Update QuadPay widget only if price changed
          updateQuadPayWidgetIfPriceChanged(newVariant, currentVariant);

          // Update current variant reference
          currentVariant = newVariant;

          // Push Monetate data for size variant change
          const productJsonSize = {
            id: productId,
            title: title,
            handle: productUrl.split('/products/')[1]?.split('?')[0] || '',
            vendor: 'Windsor',
            type: 'Regular',
            tags: productTags,
            variants: shopifyVariants,
            media: mediaArray,
            options: [
              { name: 'Color', values: colors },
              { name: 'Size', values: sizes },
            ],
            url: productUrl,
            featured_image: variantImages[0] || allProductImages[0] || productData.t,
          };
          pushMonetateData(newVariant, productJsonSize);

          // Update promo message
          const promoMessageWrapper = quickViewContent.querySelector('.ProductHeading__promo_message');
          if (promoMessageWrapper) {
            promoMessageWrapper.outerHTML = buildPromoMessage(productTags);
          }

          // Show/hide waitlist based on whether any size in the current color needs waitlist
          const waitlistModal = quickViewContent.querySelector('.WaitlistModal');
          if (waitlistModal) {
            const currentColor = newVariant.option1;
            if (shouldShowWaitlistForColor(currentColor)) {
              waitlistModal.classList.remove('WaitlistModal--hide');
              waitlistModal.classList.add('WaitlistModal--show');
            } else {
              waitlistModal.classList.remove('WaitlistModal--show');
              waitlistModal.classList.add('WaitlistModal--hide');
            }
          }

          // Toggle Add to Cart button vs Waitlist
          configureAddToCartButton(newVariant);

          // Update sold out button states for sizes
          sizeButtons.forEach((btn) => {
            const size = btn.dataset.value;
            const sizeVariant = shopifyVariants.find(
              (v) =>
                v.option2.toUpperCase() == size.toUpperCase() &&
                v.option1.toUpperCase() == newVariant.option1.toUpperCase(),
            );

            // Only mark as sold out if variant exists but is not available
            if (!sizeVariant.available) {
              btn.classList.add('ProductOption__variant--sold-out');
            } else {
              btn.classList.remove('ProductOption__variant--sold-out');
            }
          });

          // Update low stock message visibility
          const lowStockMessageWrapper = quickViewContent.querySelector(
            '.ProductInfo__inventory[data-low-inventory-message]',
          );
          if (lowStockMessageWrapper) {
            const shouldShow = shouldShowLowStock(productTags, newVariant);
            lowStockMessageWrapper.style.display = shouldShow ? 'block' : 'none';
          }

          // Update final sale message visibility
          const finalSaleMessageWrapper = quickViewContent.querySelector(
            '.ProductInfo__clearance[data-show-for-clearance]',
          );
          if (finalSaleMessageWrapper) {
            const shouldShow = shouldShowFinalSale(newVariant);
            finalSaleMessageWrapper.style.display = shouldShow ? 'block' : 'none';
          }
        }
      });
    });
  }
};
